import { StoreState } from "../RootReducer";
import * as FleetSelectors from "../Fleet/Fleet.selector";

export const getCurrentProgram = (state: StoreState) =>
	state.Program.currentProgram;

export const getProgramOverride = (state: StoreState) =>
	state.Program.programIdOverride;

export const getCurrentScopeProgramId = (state: StoreState) =>
	(FleetSelectors.selectCurrentScopeFleet(state).value || {}).programId;
